export const MinusAccordion = ({ className }: { className?: string }) => (
  <svg className={className} width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path id="minus-accordion" d="M0 5L10 5" stroke="currentColor"/>
  </svg>
)
